export default __webpack_public_path__ + "static/media/66ff20f3aa3cff6d1dfe0802763fe392.ab024ff9.png";